module.exports = __webpack_public_path__ + "img/p__北京友谊.3d589bac.png";